import * as SheetPrimitive from '@radix-ui/react-dialog';

export const SheetClose = SheetPrimitive.Close;
